module.exports = __webpack_public_path__ + "static/media/rss24grouppic.a1da4d50.jpeg";